export default function reverseAccountingNotation(s) {
    return s.toString().replace(/\((\d+(\.\d+)?)\)/, (all, number) => `-${number}`);
}
